import { TypographyProps } from '@material-ui/core';
import CustomizedTypography from '../CustomizedTypography';

interface Props extends TypographyProps {
  as?: 'span' | 'p';
  fontWeight?: '100' | '300' | '500' | '700' | '900' | 'bold' | 'normal';
  gutterBottoms?: number;
}

const CustomizedModalText = (props: Props) => {
  return <CustomizedTypography {...props} />;
};

export default CustomizedModalText;
